import { api } from '@/api'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { Media } from '@/interfaces/Media'
import React, { useState } from 'react'
import style from '../styles/media_detail.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import { arrayToChunks } from '@/utils'
import classNames from 'classnames'
import Section from '@/components/Section'
import ImageOrVideo from './ImageOrVideo'

const PhotosBlock = ({ object }): React.ReactElement => {
  const [playVideo, setPlayVideo] = useState('')

  return (
    <FetcherList
      enableReinitialize
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getMedia}
      initFilter={{ id: object.id, page_size: 100000 }}
    >
      {({ results, status }: IFetcherListResults<Media[]>) => {
        const resultChunks: Media[][] = arrayToChunks([...results], 5)
        return (
          <Section>
            {status === dataStates.loading ? <BlockSpinner /> : null}
            {status === dataStates.loaded && resultChunks.length > 0
              ? resultChunks.map((chunk, i) => {
                return (
                  <div
                    key={`chunk-${chunk[0].id}`}
                    className={classNames({
                      [style.detail_grid]: true,
                      [style['detail_grid--small']]: chunk.length <= 3,
                      [style['detail_grid--big']]: chunk.length > 3,
                      [style['detail_grid--left']]: chunk.length % 2 === 1,
                      [style['detail_grid--right']]: chunk.length % 2 === 0
                    })}
                  >
                    {chunk.map((el) => {
                      return (
                        <ImageOrVideo
                          key={`image-${el.id}`}
                          id={el.id}
                          playVideo={playVideo}
                          setPlayVideo={setPlayVideo}
                          video={el?.property_video_value}
                          image={el.property_real_picture_value?.[0]}
                          title={el.name}
                          chunkLength={chunk.length}
                        />
                      )
                    })}
                  </div>
                )
              })
              : null}
          </Section>
        )
      }}
    </FetcherList>
  )
}

export default PhotosBlock
